// extracted by mini-css-extract-plugin
export default {"icon":"icon-aV2D","item":"item-A94F"};